/**
 * @generated SignedSource<<2b8f1c339a25034934518efda5a482b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTaxExemptionCheckbox_viewer$data = {
  readonly isMultiStageCheckoutOn: boolean | null;
  readonly " $fragmentType": "CheckoutTaxExemptionCheckbox_viewer";
};
export type CheckoutTaxExemptionCheckbox_viewer$key = {
  readonly " $data"?: CheckoutTaxExemptionCheckbox_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTaxExemptionCheckbox_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTaxExemptionCheckbox_viewer",
  "selections": [
    {
      "alias": "isMultiStageCheckoutOn",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiStageCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiStageCheckout\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7ee806f6a312dbbc98b6530a113c91dd";

export default node;
